import styled from 'styled-components'

/**
 * User profile style
 */
export const InfoCardWrap = styled.div`
  padding: 15px;
`

export const AvatarWrap = styled.div`
  text-align: ${props => props.avatarAlignment};
  img {
    width: 96px;
    height: 96px;
    object-fit: cover;
    border-radius: 50%;
  }
`

export const InfoWrap = styled.div`
  margin-top: 15px;
  text-align: ${props => props.contentAlignment};
`

export const InfoBottom = styled.div`
  display: flex;
  justify-content: space-around;
`

export const StaffID = styled.div`
  font-size: 1rem;
  color: rgba(255, 255, 255, 1);
  margin-top: 15px;
  padding: 2% 0;
`

export const StaffName = styled.div`
  color: rgba(255, 255, 255, 1);
  font-weight: bolder;
  font-size: 1.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const JobTitle = styled.div`
  color: rgba(255, 255, 255, 1);
  font-size: 1rem;
  font-family: serif;
  font-style: italic;
  padding: 5px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Department = styled.div`
  color: rgba(255, 255, 255, 1);
  font-size: 0.9rem;
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  font-weight: bolder;
`

export const Email = styled.div`
  font-size: 0.9rem;
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  a {
    color: ${props => props.theme.palette.primary2Color};
    text-decoration: none;
  }
`

export const InfoBottomContent = styled.div`
  text-align: center;
  margin-top: 15px;
`

export const Number = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
`

export const Label = styled.div``

export const CompanyAbbr = styled.div`
  position: absolute;
  top: 15px;
  right: 30px;
  font-weight: bold;
  color: #fff;
`



// WEBPACK FOOTER //
// ./src/components/InfoCardProfile/styled-components.js